var _path, _rect, _line, _line2, _path2, _line3, _line4, _line5, _path3, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71414 1C5.71414 0.447715 6.16186 0 6.71414 0H14.9999C15.5521 0 15.9999 0.447715 15.9999 1V18.2857H5.71414V1Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.14261,
    y: 12.5714,
    width: 4.57143,
    height: 5.71429,
    fill: "#DBFFE3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.00037,
    y1: 5.21426,
    x2: 13.7147,
    y2: 5.21426,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.7858,
    y1: 2.28571,
    x2: 10.7858,
    y2: 7.99999,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 3.42856H20.714C21.2663 3.42856 21.714 3.87627 21.714 4.42856V17.2857C21.714 17.838 21.2663 18.2857 20.714 18.2857H17.1426V3.42856Z",
    fill: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2857,
    y1: 6.35715,
    x2: 21.7142,
    y2: 6.35715,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2857,
    y1: 9.78571,
    x2: 21.7142,
    y2: 9.78571,
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2857,
    y1: 13.2143,
    x2: 21.7142,
    y2: 13.2143,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000183105 4.42856C0.000183105 3.87627 0.447898 3.42856 1.00018 3.42856H4.57161V18.2857H1.00018C0.447899 18.2857 0.000183105 17.838 0.000183105 17.2857V4.42856Z",
    fill: "currentColor"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.000366211,
    y1: 6.35715,
    x2: 3.42894,
    y2: 6.35715,
    stroke: "white"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.000366211,
    y1: 9.78571,
    x2: 3.42894,
    y2: 9.78571,
    stroke: "white"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.000366211,
    y1: 13.2143,
    x2: 3.42894,
    y2: 13.2143,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicFull);
export default __webpack_public_path__ + "static/media/ClinicFull.4aff65c10059b8318586ec6d4ad92ebf.svg";
export { ForwardRef as ReactComponent };